module.exports = __webpack_public_path__ + "static/jumbotron-b5940ffecae6a31b168ed5c16d578cda.jpeg";